/* eslint-disable */
import { utilCookies } from '@/util/cookies';
import { lang } from '@/lang';
var state = {
  showSettings: false,
  fixedHeader: true,
  sidebarLogo: false,
  contentViewHeight: 0,
  langArr: lang.langList,
  curLang: lang.curLang,
  // 主题色
  themeColor: null
};
var mutations = {
  CHANGE_SETTING: function CHANGE_SETTING(state, _ref) {
    var key = _ref.key,
      value = _ref.value;
    if (state.hasOwnProperty(key)) {
      state[key] = value;
    }
  },
  updateContentViewHeight: function updateContentViewHeight(store, height) {
    store.contentViewHeight = height;
  },
  updateCurLang: function updateCurLang(store, data) {
    store.curLang = data;
    utilCookies.setLanguage(data['key']);
    window.location.reload();
  },
  // 主题色
  CHANGE_COLOR: function CHANGE_COLOR(store, val) {
    store.themeColor = val;
  }
};
var actions = {
  changeSetting: function changeSetting(_ref2, data) {
    var commit = _ref2.commit;
    commit('CHANGE_SETTING', data);
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};